import store from '@/store/index.js';
import { isAllowed } from '../utils/authentication';
const LOGOUT_PATH = '/callback-logout';
const LOGIN_PATH = '/callback-login';

export function routerBeforeEach(to, from, next) {
  // store.dispatch('authentication/initAuthentication')
  if (to.path === LOGIN_PATH) {
    store.dispatch('authentication/handleLoginResponse').then(() => {
      next('/');
    });
  } else if (to.path === LOGOUT_PATH) {
    next();
  } else {
    const currentUser = store.getters['authentication/user'];
    // we need to chek in to.matched (cause children)
    const canVisitPage = to.matched.some(record => {
      if (record.meta && record.meta.authorization) {
        return isAllowed(
          currentUser,
          record.meta.authorization.role,
          record.meta.authorization.divisions
        );
      }
      return true;
    });

    if (!canVisitPage) {
      if (currentUser && currentUser.role) {
        next('/forbidden');
      } else {
        next('/unregistered');
      }
    } else {
      next();
    }
  }
}
